import { render, staticRenderFns } from "./AdminAccommodationLinks.vue?vue&type=template&id=4e4ab0c0&scoped=true"
import script from "./AdminAccommodationLinks.vue?vue&type=script&lang=js"
export * from "./AdminAccommodationLinks.vue?vue&type=script&lang=js"
import style0 from "./AdminAccommodationLinks.vue?vue&type=style&index=0&id=4e4ab0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ab0c0",
  null
  
)

export default component.exports